import { css } from '@emotion/react';
import { darkThemeStyle, theme } from '../theme';
import { tokens } from '../tokens';
// Mapping between select's sizes and design tokens
const sizeMap = {
    large: {
        sizing: tokens.sizing.large,
        spacing: tokens.spacingNew.medium,
        spacingWithIcon: '40px',
    },
    medium: {
        sizing: tokens.sizing.medium,
        spacing: tokens.spacingNew.small,
        spacingWithIcon: '36px',
    },
    small: {
        sizing: tokens.sizing.small,
        spacing: tokens.spacingNew.small,
        spacingWithIcon: tokens.spacingNew.xlarge,
    },
};
const selectWrapperStaticStyle = css({
    '&::after': {
        borderRadius: '6px',
        content: '""',
        display: 'block',
        inset: 0,
        margin: '-2px',
        pointerEvents: 'none',
        position: 'absolute',
        transition: 'box-shadow 125ms ease-out',
        zIndex: tokens.zIndex.default,
    },
    position: 'relative',
    width: '100%',
});
export function selectWrapperStyle({ disabled, inverted, isFocused, size, }) {
    return [
        ...(inverted ? [darkThemeStyle] : []),
        selectWrapperStaticStyle,
        css(Object.assign({ height: sizeMap[size].sizing, opacity: disabled ? tokens.opacity.medium : 1 }, (isFocused && {
            '&::after': {
                boxShadow: `0 0 0 2px ${theme.border.focusOutline}`,
            },
        }))),
    ];
}
const selectStaticStyle = css({
    '  &:disabled': {
        cursor: 'default',
    },
    appearance: 'none',
    backgroundColor: theme.background.contrast,
    border: `${tokens.borderWidth.thin} solid ${theme.border.strong}`,
    borderRadius: tokens.borderRadius.medium,
    color: theme.text.main,
    cursor: 'pointer',
    display: 'flex',
    fontFamily: tokens.fontFamilies.sansSerif,
    fontWeight: tokens.fontWeights.regular,
    height: '100%',
    lineHeight: tokens.lineHeights.relaxed,
    outline: 0,
    width: '100%',
});
export function selectStyle({ hasError, hasIcon, size, withPlaceholder, }) {
    return [
        selectStaticStyle,
        css(Object.assign(Object.assign({ fontSize: tokens.fontSizes[size], paddingLeft: hasIcon
                ? sizeMap[size].spacingWithIcon
                : sizeMap[size].spacing, paddingRight: sizeMap[size].spacingWithIcon }, (withPlaceholder && {
            color: theme.text.subtle,
        })), (hasError && {
            borderColor: theme.error.darker,
            boxShadow: `0 0 0 1px ${theme.error.darker}`,
        }))),
    ];
}
const iconStaticStyle = css({
    alignItems: 'center',
    color: theme.text.main,
    display: 'flex',
    height: '100%',
    pointerEvents: 'none',
    position: 'absolute',
    top: 0,
    zIndex: tokens.zIndex.default,
});
export function iconLeftStyle({ size }) {
    return [
        iconStaticStyle,
        css({
            left: sizeMap[size].spacing,
        }),
    ];
}
export function iconRightStyle({ size }) {
    return [
        iconStaticStyle,
        css({
            right: sizeMap[size].spacing,
        }),
    ];
}
